"use client";

import * as React from "react";
import { Stack, Card, CardContent, Typography } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";

type TertiaryPaneContentCardsProps = {
  tertiaryNavItems: HeaderNavProps[];
};
export default function TertiaryNavigationPaneContentCards(props: TertiaryPaneContentCardsProps) {
  const { tertiaryNavItems } = props;

  return (
    <Stack 
      direction="row" 
      spacing={2} 
      sx={{ p: .5, pt: 4, ml:2, minHeight: "300px", maxWidth: "180px" }}      
    >
      <Card
        className="navTile"
        data-nav-level="tile"
        data-nav-label={tertiaryNavItems[0]?.fields.content?.content[0]?.content[0]?.value ?? "tile"}
        sx={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          py: 2,
          px: 2,
          overflow: "hidden",
          flexDirection: "column",
          alignItems: "initial",
          gap: 1,
          backgroundColor: "primary.main",
          borderRadius: "25px",
          borderBottomLeftRadius: "0px"
        }}
        data-testid={`tertiary-pane-content-card-${tertiaryNavItems[0]?.fields.title}`}
      >
        <CardContent>
          <Typography variant="h2" sx={{ color: "primary.contrastText", pt:.5, pl:.5, fontSize: "1.5rem", fontWeight: "600", lineHeight: "23px" }}>
            {tertiaryNavItems[0]?.fields.content?.content[0]?.content[0]?.value}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
}
